module.exports = __webpack_public_path__ + "static/media/odder.9fe5bfcf.svg";